/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type BankProductPaginatedProperty =
  typeof BankProductPaginatedProperty[keyof typeof BankProductPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BankProductPaginatedProperty = {
  NAME: 'NAME',
  PRODUCT_TYPE: 'PRODUCT_TYPE',
  BANK_NAME: 'BANK_NAME',
  GROSS_RATE: 'GROSS_RATE',
  HELD: 'HELD',
  MAX_AVAILABLE: 'MAX_AVAILABLE',
  CREATED_AT: 'CREATED_AT',
} as const;
